import React, { useEffect, useState } from 'react';
import PropTypes from 'prop-types';
import Quote from '../../classes/Quote';
import store, { resetQuotes } from '../../states/Store';
import BasisTable from '../tables/BasisTable';
import QuoteTable from '../tables/QuoteTable';
import '../../classes/Extensions';

const types = [
  ['DEPO'],
  ['FUT'],
  ['OIS'],
  ['IRS'],
  ['DBS'],
  ['FX', 'XCS'],
  ['CPI', 'ZCIS']
];

const legends = [
  'Deposits',
  '3M Futures',
  'OIS Swaps',
  'IR Swaps',
  'Basis Spreads',
  'Forex',
  'Inflation'
];

const headers = [
  ['Tenor', 'Rate'],                        // DEPO
  ['Month', 'Price','Volatility', 'Yield'], // FUT
  ['Term', 'Rate'],                         // OIS
  ['Tenor', 'Term', 'Rate'],                // IRS
  ['Term', '0s3s', '1s3s', '3s6s'],         // DBS
  ['Type', 'Tenor', 'Quote'],               // FX
  ['Term', 'Quote']                         // CPI
];

const properties = [
  ['Maturity', 'Value'],                                 // DEPO
  ['Maturity', 'Value','Volatility', 'Yield'],           // FUT
  ['Maturity', 'Value'],                                 // OIS
  ['Tenor', 'Maturity', 'Value'],                        // IRS
  [],                                                    // DBS: not used
  ['Type', 'Maturity', 'Value'],                         // FX
  ['Maturity', 'Value']                                  // CPI
];

const isAlignLeft = [
  [true, false],                       // DEPO
  [true, false,false, false],          // FUT
  [true, false],                       // OIS
  [true, true, false],                 // IRS
  [true, false, false, false],         // DBS
  [true, true, false],                 // FX
  [true, false]                        // CPI
];

const isInput = [
  [false, true],                       // DEPO
  [false, true,true, false],           // FUT
  [false, true],                       // OIS
  [false, false, true],                // IRS
  [false, true, true, true],           // DBS
  [false, false, true],                // FX
  [false, true]                        // CPI
];


export default function QuotePage() {
  const [quotes, setQuotes] = useState(store.MarketData.Current.Quotes.getValue());

  useEffect(() => {
    store.MarketData.Current.Quotes.subscribe((quotes) => setQuotes(quotes));
  })

  return (
    <div>
      {types.map((types: string[], index: number) => {
        if(!quotes || quotes.length === 0) {
          resetQuotes();
          return '';
        }
        const lquotes = quotes.filter((quote: Quote) => types.indexOf(quote.Type) !== -1)
        if (!lquotes || lquotes.length === 0) return '';
        switch (types[0]) {
          case 'DBS':
            return (<BasisTable key='DBS' Quotes={lquotes} />)
          default:
            return (<QuoteTable
              key={legends[index]}              
              legend={legends[index]}
              headers={headers[index]}
              properties={properties[index]}
              quotes={lquotes}
              isAlignLeft={isAlignLeft[index]}
              isInput={isInput[index]} />
            )}
      })}
    </div>
  );
}

QuotePage.propTypes = {
  Quotes: PropTypes.array,
};